import type {
  ParsedAttributeQuery,
  SmartSearchOperationalHit,
} from '../types'

import { foldSearchText } from './foldSearchText'
import { matchesAttributeHaystack } from './matchAttributeHaystack'
import { hasPositiveTerms } from './parseAttributeQuery'

// haystack for user fields (layer + audit object)
export function foldedUserHaystack(hit: SmartSearchOperationalHit): string {
  const parts: string[] = []

  const pushLayerCreator = () => {
    const uid = hit.layerCreatorUserId
    const uname = hit.layerCreatorUsername?.trim()
    if (uid != null && uid !== undefined && !Number.isNaN(Number(uid))) {
      parts.push(foldSearchText(String(uid)))
    }
    if (uname) parts.push(foldSearchText(uname))
  }

  if (hit.kind === 'feature') {
    pushLayerCreator()
    const p = hit.feature.properties
    if (p && typeof p === 'object' && !Array.isArray(p)) {
      const o = p as Record<string, unknown>
      for (const k of [
        'elda_created_by_username',
        'elda_created_by_user_id',
        'elda_updated_by_username',
        'elda_updated_by_user_id',
      ]) {
        const v = o[k]
        if (v !== null && v !== undefined && String(v).trim() !== '') {
          parts.push(foldSearchText(String(v)))
        }
      }
    }
  } else {
    pushLayerCreator()
  }

  return parts.filter(Boolean).join(' ')
}

// tags with user name displaying dynamically with input search
export function userMatchTags(
  parsed: ParsedAttributeQuery,
  hit: SmartSearchOperationalHit,
): string[] {
  if (!hasPositiveTerms(parsed)) return []

  const userHay = foldedUserHaystack(hit)
  if (!userHay.trim()) return []

  if (!matchesAttributeHaystack(userHay, parsed)) return []

  const layerUn = hit.layerCreatorUsername?.trim() ?? ''
  const layerUid = hit.layerCreatorUserId

  if (hit.kind === 'layer') {
    if (layerUn) return [`Créée par ${layerUn}`]
    if (layerUid != null && !Number.isNaN(Number(layerUid))) {
      return [`Créée par · id ${layerUid}`]
    }
    return []
  }

  const tags: string[] = []
  const p = hit.feature.properties as Record<string, unknown> | undefined
  const createdUn =
    p?.elda_created_by_username != null
      ? String(p.elda_created_by_username).trim()
      : ''
  const updatedUn =
    p?.elda_updated_by_username != null
      ? String(p.elda_updated_by_username).trim()
      : ''

  const layerLower = layerUn.toLowerCase()
  const createdLower = createdUn.toLowerCase()

  if (layerUn) tags.push(`Couche · ${layerUn}`)
  else if (layerUid != null && !Number.isNaN(Number(layerUid))) {
    tags.push(`Couche · id ${layerUid}`)
  }

  if (createdUn && createdLower !== layerLower) {
    tags.push(`Créé · ${createdUn}`)
  }

  if (updatedUn && updatedUn !== createdUn) {
    tags.push(`Modif. · ${updatedUn}`)
  }

  return tags
}
